export const FIELD_ID = {
  invoice: {
    serviceBundle: 171920,
    businessGroup: 170992,
    invoiceDate: 170978,
    currency: 170993,
  },
  invoiceDetail: {
    serviceBundle: 171943,
    businessGroup: 171145,
  },
}
